import { PropsWithChildren } from 'react';

import View from '../View';

type Props = {};

const Item = ({ children }: PropsWithChildren<Props>) => <View>{children}</View>;

export default Item;
